import { useState } from "react";

interface DriverNotesBlockProps {
  notes: string;
}

export const DriverNotesBlock = ({ notes }: DriverNotesBlockProps) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = notes.length > 120;

  return (
    <div className="bg-accent/10 border border-accent/20 rounded-md p-2 mt-1.5">
      <p className="text-[10px] font-medium text-accent mb-0.5">📝 Driver Notes</p>
      <p
        className={`text-xs text-foreground whitespace-pre-wrap ${
          !expanded && isLong ? "line-clamp-2" : ""
        }`}
      >
        {notes}
      </p>
      {isLong && (
        <button
          type="button"
          className="text-[10px] font-medium text-primary mt-0.5"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded((v) => !v);
          }}
        >
          {expanded ? "Less" : "More"}
        </button>
      )}
    </div>
  );
};
